<template>
  <div class="bubble-chart"  v-inview="{ callback: onInview }">
    <div class="bubble-chart__caption">藍綠選區分層選舉人數圖</div>
    <div class="bubble-chart__bubbles">
      <div class="bubble-chart__bubbles-dsitributed" :class="{ 'draw-bubble': isIntersection }">
          <div class="bubble-chart__bubble" v-for="(item, index) in data"
            :key="index"
            :style="{ top: pos[index].top + '%', left: pos[index].left + '%', }"
          >
            <div class="bubble-chart__ball" :style="{ backgroundColor: item.color, transitionDelay: item.id / 3 + 's'}"></div>
            <div class="bubble-chart__ball-infor" :style="{transitionDelay: item.id / 3 + 's'}">
              <div class="bubble-chart__infor-amount">{{ item.amount }}人</div>
              <div class="bubble-chart__infor-percentage">{{ item.percentage }}%</div>
            </div>
          </div>
      </div>
    </div>
    <div class="bubble-chart__legends">
      <div class="bubble-chart__legend" v-for="(item, index) in data" :key="index"><!--
        --><div class="bubble-chart__icon" :style="{ backgroundColor: item.color}"></div><!--
        --><div class="bubble-chart__label" :style="{ color: item.color}">第{{ item.id }}組</div>
      </div>
    </div>
    <div class="bubble-chart__chart-guide clearfix">
      <p>資料範圍：台南第六選區</p>
      <p>顯示數值：該組選舉人數及占第六區總選舉人數百分比</p>
    </div>
    <div class="bubble-chart__chart-guide clearfix">
      資料來源：中選會/本文自行彙整
    </div>
  </div>
</template>

<script>
const BUBBLEDATA = [
  {
    id: 1,
    color: '#0d3587',
    amount: 1354,
    percentage: 0.53,
    ranking: 10
  }, {
    id: 2,
    color: '#506da8',
    amount: 68829,
    percentage: 26.85,
    ranking: 26
  }, {
    id: 3,
    color: '#8bc5c2',
    amount: 42547,
    percentage: 16.59,
    ranking: 17
  }, {
    id: 4,
    color: '#85d1a4',
    amount: 52791,
    percentage: 20.59,
    ranking: 20
  }, {
    id: 5,
    color: '#33b268',
    amount: 61779,
    percentage: 24.10,
    ranking: 24
  }, {
    id: 6,
    color: '#009f42',
    amount: 29066,
    percentage: 11.34,
    ranking: 11
  }
]

const DATAPOS = [
  {
    id: 1,
    top: 48.6,
    left: 5.5
  }, {
    id: 2,
    top: 5.4,
    left: 8.8
  }, {
    id: 3,
    top: 47.3,
    left: 33
  }, {
    id: 4,
    top: 5,
    left: 46
  }, {
    id: 5,
    top: 55,
    left: 58.9
  }, {
    id: 6,
    top: 8.9,
    left: 75
  }
]

export default {
  name: 'BubbleChart',
  data () {
    return {
      data: BUBBLEDATA,
      pos: DATAPOS,
      isIntersection: false
    }
  },
  methods: {
    onInview (entries) {
      this.isIntersection = true
    }
  },
  activated () {
    // this.observer = new IntersectionObserver(this.onIntersection, {
    //   root: null,
    //   rootMargin: '0px 0px',
    //   threshold: [0.2]
    // })

    // this.observer.observe(this.$el)
  }
}
</script>

<style lang="scss">
.bubble-chart {
  width: 100%;
  max-width: 840px;
  margin: 0 auto;
  padding: 40px 20px;

  @include rwd($RWD_TABLET_SMALL) {
    padding: 40px 35px;
  }

  @include rwd($RWD_TABLET) {
    padding: 40px 50px;
  }

  @include rwd($RWD_DESKTOP) {
    padding: 60px 70px;
  }

  &__bubbles {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 68.9%;
    border-radius: 3px;
  }

  &__bubbles-dsitributed {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  &__bubble {
    position: absolute;
    width: 5%;
    height: 7.14%;
    text-align: center;
  }

  &__ball {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    border-radius: 50%;
    transform: scale(0);
    transition: transform 0.3s ease;
  }

  &__ball-infor {
    position: relative;
    display: inline-block;
    text-align: center;
    color: #1a1a1a;
    font-weight: bold;
    opacity: 0;
    transition: opacity 0.3s ease;
    vertical-align: middle;
    margin-top: 110%;
  }

  &__infor-amount {
    font-size: 0.8125em;
    white-space: nowrap;
    line-height: 1;
  }

  &__infor-percentage {
    font-size: 0.9375em;
    border-radius: 3px;
    white-space: nowrap;

    @include rwd($RWD_TABLET_SMALL) {
      line-height: 1;
      font-size: 1.125rem;
      margin-top: 3px;
    }
  }

  &__legends {
    position: relative;
    width: 100%;
    padding-top: 10px;
    font-size: 0.9375em;
  }

  &__legend {
    position: relative;
    display: inline-block;
    width: 33.33%;
    text-align: center;

    @include rwd($RWD_TABLET_SMALL) {
      width: 16.66%;
    }
  }

  &__icon {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 12px;
    height: 12px;
    margin-top: -6px;
    margin-left: -35px;
    border-radius: 50%;
    vertical-align: middle;
  }

  &__label {
    display: inline-block;
    vertical-align: middle;
  }

  &__caption {
    padding-bottom: 15px;
    font: normal 100%/150% "Montserrat", "Noto Sans TC", "Noto Serif TC", sans-serif;
    font-size: 0.9375em;
    text-align: center;

    @include rwd($RWD_TABLET) {
      font-size: 1em;
    }

    @include rwd($RWD_DESKTOP) {
      padding-bottom: 20px;
    }
  }

  &__chart-guide {
    margin: 10px 5px 0 5px;
    color: #7e7e7e;
    font: normal 100%/150% "Montserrat", "Noto Sans TC", "Noto Serif TC", sans-serif;
    font-size: 0.75em;
    text-align: right;
  }

  &__chart-guide p {
    margin-block-start: 0;
    margin-block-end: 0;

    @include rwd($RWD_TABLET) {
      float: left;

      & + p {
        float: right;
      }
    }
  }
}
</style>

<style lang="scss">
  .draw-bubble {
    .bubble-chart__ball-infor {
      opacity: 1;
    }

    .bubble-chart__ball {
      transform: scale(1);
    }
  }

  .bubble-chart__bubble +.bubble-chart__bubble {
    width: 26%;
    height: 37.2%;

    @include rwd($RWD_TABLET_SMALL) {
      @include use-vertical-align();
    }

    .bubble-chart__ball-infor {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      margin-top: 0;
    }
  }

  .bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble {
    width: 17%;
    height: 24.6%;
  }

  .bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble {
      width: 20%;
      height: 28.5%;
  }

  .bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble {
      width: 24%;
      height: 34.2%;
  }

  .bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble +.bubble-chart__bubble {
      width: 11%;
      height: 15.7%;

      &::before {
        content: none;
      }

      .bubble-chart__ball-infor {
        position: relative;
        left: auto;
        right: auto;
        transform: none;
        margin-top: 60%;
      }
  }
</style>
